<template>
    <div class="card-presenter-container" v-on:click="close">
        <transition name="card-presenter-toggle" v-on:after-leave="afterHidden">
            <div class="card-presenter" v-if="show" v-on:click="stopClickPropagation($event)">
                <div class="card-image-container">
                    <a v-if="presentation.props.PresenterProfiles && presentation.props.PresenterProfiles.profiles.length > 1" class="prev-next-button prev" v-on:click="scrollProfile('left')">
                        <i class="fa fa-chevron-left align-arrow"></i>
                    </a>
                    <img v-if="presentation.props.PresenterInfo" class="card-image" :src="presentation.props.PresenterInfo.pictureURL" onerror='this.onerror = "null"; this.src = "/static/img/anonymous.svg"'>
                    <img v-else-if="presentation.props.PresenterProfiles" class="card-image" :src="presentation.props.PresenterProfiles.profiles[profileIndex].pictureURL" onerror='this.onerror = "null"; this.src = "/static/img/anonymous.svg"'>
                    <img v-else class="card-image" src="../assets/icons/anonymous.svg">  
                    <a v-if="presentation.props.PresenterProfiles && presentation.props.PresenterProfiles.profiles.length > 1" class="prev-next-button next" v-on:click="scrollProfile('right')">
                        <i class="fa fa-chevron-right align-arrow"></i>
                    </a> 
                </div>            
                <h5 v-if="presentation.props.PresenterInfo" class="card-title">{{presentation.props.PresenterInfo.displayName}}</h5>
                <h5 v-else-if="presentation.props.PresenterProfiles" class="card-title">{{presentation.props.PresenterProfiles.profiles[profileIndex].displayName}}</h5>
                <div class="link-collection">
                    <div v-if="presentation.props.PresenterInfo" class="card-links">
                        <div v-for="(item, index) in presentation.props.PresenterInfo.items" :key="index">
                            <presenterLink :item="item"></presenterLink>
                        </div>
                    </div>
                    <div v-else-if="presentation.props.PresenterProfiles" class="card-links">
                        <div v-for="(item, index) in presentation.props.PresenterProfiles.profiles[profileIndex].items" :key="index">
                            <presenterLink :item="item"></presenterLink>
                        </div>
                    </div>
                </div>
                <div class="card-presenter-footer">
                    <a v-on:click="close">{{$t('str.Close')}}</a>
                </div>
                <a v-on:click="close" class="close-button">
                    <i class="fa fa-times"></i>
                </a>
            </div>
        </transition>
    </div>
</template>

<script>

import PresenterLink from '@/components/PresenterLink';

export default {
    components: {
        presenterLink: PresenterLink
    },

    props: {
        presentation: {},
        profileIndex: ''
    },

    data() {
        return {
            show: false
        };
    },

    methods: {
        scrollProfile(direction) {
            this.$emit('scrollProfile', direction);
        },

        close() {
            this.show = false;
        },

        afterHidden() {
            this.$emit('closeCard');
        },

        stopClickPropagation(event) {
            if (event && event.stopPropagation) {
                event.stopPropagation();
            }
        }
    },

    mounted() {
        setTimeout(() => {
            this.show = true;
        }, 1);
        
    }
};

</script>

<style lang="scss">

.card-presenter-toggle-enter-active, .card-presenter-toggle-enter-to, .card-presenter-toggle-leave-active {
    transition: all 0.3s;
}

.card-presenter-toggle-enter, .card-presenter-toggle-leave-to {
    opacity: 0;
    transform: translateY(300px);
}

.card-presenter-container {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    overflow: auto;
}

.card-presenter {
    max-height: 450px;
    min-height: 300px;
    width: 280px;
    margin: 0 auto;
    background-color: #fff;
    border: 9px solid rgba(0,0,0,0.25);
    overflow-y: auto;
    font-family: "Poppins", sans-serif;
    font-size: 1rem;
    line-height: 1.5;
    position: relative;

    .card-image-container {
        position: relative;
        margin-top: 0;
        box-sizing: inherit;

        .prev {
            position: absolute;
            top: 41%;
            left: 10%;
        }

        .next {
            position: absolute;
            top: 41%;
            left: 75%;
        }

        .prev-next-button {
            color: #bbb;
            cursor: pointer;

            .align-arrow {
                margin-left: 12px;
                margin-right: 10px;
            }
        }
  
        .prev-next-button:hover {
            color:#D4451D;
        }

        .card-image {
            display: block;
            left: 0px;
            right: 0px;
            top: 0px;
            bottom: 0px;
            width: 40%;
            max-height: 40%;
            border-radius: 50%;
            margin: 15px auto 0;
            border: 5px solid rgba(0,0,0,0.05);
            position: relative;
        }
    }
    
    .card-title {
        font-size: 1em;
        font-weight: 700;
        white-space: pre-wrap;
        width: 100%;
        color: #333;
        text-align: center;
        margin: 12px 0;
    }

    .link-collection {
        margin-bottom: 20px;
        font-size: 0.9em;
        user-select: none;

        .card-links {
            list-style-type: none;
            padding: 0;
            text-align: center;
            max-height: 150px;
            overflow-y: auto;

            .card-link {
                line-height: 2.2em;

                    a {
                        text-decoration: none;
                        color: #D4451D;
                    }
            }
        }
    }

    .close-button {
        font-size: 20px;
        color: rgba(0,0,0,0.25);
        margin: 20px;
        position: absolute;
        top: 0px;
        right: 0px;
        cursor: pointer;
    } 

    .card-presenter-footer {
        padding: 15px 20px 10px 20px;
        text-transform: uppercase;
        color: #d4451d;
        float: right;

        a {
            cursor: pointer;
        }
    }              
}

</style>



// WEBPACK FOOTER //
// PresenterCard.vue?716004e3